export interface SavedLocation {
  city: string;
  state: string;
  cnpj?: string;
  cep?: string;
  addressNumber?: string;
  logradouro?: string;
  neighborhood?: string;
  regionId?: string;
  skipMindCatalog?: boolean;
}

export interface LocationState {
  location: SavedLocation | null;
}

export const initialState: LocationState = {
  location: null,
};
